import React from 'react';
import PropTypes from "prop-types";

class WithUserState extends React.Component {
  static propTypes = {
    state: PropTypes.string.isRequired
  };

  constructor(props) {
    super(props);

    this.state = {
      loggedIn: window.user.signedIn(),
      indexKey: new Date().getTime()
    }
  }

  componentDidMount() {
    window.addEventListener('userStatusChanged', this.onUserStateChange.bind(this))
  }

  componentWillUnmount() {
    window.removeEventListener('userStatusChanged', this.onUserStateChange.bind(this))
  }

  onUserStateChange() {
    this.setState({
      loggedIn: window.user.signedIn(),
      indexKey: new Date().getTime()
    })
  }

  render() {
    const { loggedIn } = this.state;

    switch (this.props.state) {
      case "loggedIn":
      case "signedIn":
        if (!loggedIn) {
          return "";
        }

        return <React.Fragment key={this.state.indexKey}>{this.props.children || ""}</React.Fragment>;
      default:
        if (loggedIn) {
          return "";
        }

        return <React.Fragment key={this.state.indexKey}>{this.props.children || ""}</React.Fragment>;
    }
  }
}

export default WithUserState;